import { Injectable, Injector, NgZone } from '@angular/core';
import { Subject, timer } from 'rxjs';
import { switchMap, takeUntil } from 'rxjs/operators';
import { ACCOUNTSTATUS } from '../constants/practice.constant';
import { PracticeService } from './practice.service';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class AccountStatusService {
  private isRunning = false;
  private stop$ = new Subject<void>();

  constructor(
    private practiceService: PracticeService,
    private injector: Injector,
    private ngZone: NgZone
  ) { }

  startChecking(practiceId: number) {
    if (this.isRunning) {
      console.log("service alredy running");
      return;
    }
    if (practiceId == null || practiceId <= 0)
    {
      return;
    }
    this.isRunning = true;
    console.log("started service to check account status");
    const authService = this.injector.get(AuthService);

    this.ngZone.runOutsideAngular(() => {

      timer(0, 300000) // run immediately then every 5 minutes
        .pipe(
          takeUntil(this.stop$),
          switchMap(() =>
            this.practiceService.getPracticeAccountStatus(practiceId)
          )
        )
        .subscribe((response: any) => {
          const status = response?.data?.status;
          const lastStatus = localStorage.getItem("lastAccountStatus");
          if (status == ACCOUNTSTATUS.AccountClosed) {
            this.ngZone.run(() => {
              authService.logout();
            });
          }
          if (status == ACCOUNTSTATUS.PracticeSuspended && lastStatus != ACCOUNTSTATUS.PracticeSuspended.toString()) {             
            localStorage.setItem("lastAccountStatus", ACCOUNTSTATUS.PracticeSuspended.toString());
            this.ngZone.run(() => {
              authService.submitForAutoLoginLogout();
            });
          }
          if (status == ACCOUNTSTATUS.PracticeActive && lastStatus == ACCOUNTSTATUS.PracticeSuspended.toString()) {   
            localStorage.setItem("lastAccountStatus", ACCOUNTSTATUS.PracticeActive.toString());
            this.ngZone.run(() => {
              authService.submitForAutoLoginLogout();
            });
          }
          if (!lastStatus) {
            localStorage.setItem("lastAccountStatus", status);
          }
        });

    });
  }

  stopChecking() {
    console.log("stop service to check account status");
    this.stop$.next();
    this.isRunning = false;
    localStorage.removeItem('lastAccountStatus');
  }
}